import React from "react";
import { Formik } from "formik";
import PropTypes from "prop-types";

export const CustomForm = ({ initialValues, validationSchema, onSubmit, render, ...props }) => (
  <Formik
    initialValues={initialValues}
    onSubmit={onSubmit}
    validationSchema={validationSchema}
    {...props}
  >
    {(formikProps) => render(formikProps)}
  </Formik>
);

CustomForm.propTypes = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  render: PropTypes.func.isRequired,
  validationSchema: PropTypes.object,
};
